<div class="flex items-start justify-between gap-4 rounded-lg">
  <div class="flex flex-wrap gap-2">
    @if (filterCriteria()?.priority?.length) {
      @for (priority of filterCriteria()?.priority ?? []; track priority) {
        <span
          class="inline-flex items-center gap-2 px-3 py-1.5 bg-white border border-gray-300 rounded-lg text-sm text-text-primary"
        >
          <span class="font-medium">{{ 'shared.filterSidebar.sections.priority' | translate }}:</span>
          <span>{{ getPriorityName(priority) }}</span>
        </span>
      }
    }
    @if (filterCriteria()?.region?.length) {
      @for (region of filterCriteria()?.region ?? []; track region) {
        <span
          class="inline-flex items-center gap-2 px-3 py-1.5 bg-white border border-gray-300 rounded-lg text-sm text-text-primary"
        >
          <span class="font-medium">{{ 'shared.filterSidebar.sections.region' | translate }}:</span>
          <span>{{ region.name }}</span>
        </span>
      }
    }
    @if (filterCriteria()?.sites?.length) {
      @for (site of filterCriteria()?.sites ?? []; track site) {
        <span
          class="inline-flex items-center gap-2 px-3 py-1.5 bg-white border border-gray-300 rounded-lg text-sm text-text-primary"
        >
          <span class="font-medium">{{ 'shared.filterSidebar.sections.site' | translate }}:</span>
          <span>{{ site.name }}</span>
        </span>
      }
    }
    @if (filterCriteria()?.examType?.length) {
      @for (examType of filterCriteria()?.examType ?? []; track examType) {
        <span
          class="inline-flex items-center gap-2 px-3 py-1.5 bg-white border border-gray-300 rounded-lg text-sm text-text-primary"
        >
          <span class="font-medium">{{ examTypeLabel() | translate }}:</span>
          <span>{{ examType.name }}</span>
        </span>
      }
    }
    @if (filterCriteria()?.status?.length) {
      @for (status of filterCriteria()?.status ?? []; track status) {
        <span
          class="inline-flex items-center gap-2 px-3 py-1.5 bg-white border border-gray-300 rounded-lg text-sm text-text-primary"
        >
          <span class="font-medium">{{ 'shared.filterSidebar.sections.sampleStatus' | translate }}:</span>
          <span>{{ getStatusName(status) }}</span>
        </span>
      }
    }
    @if (filterCriteria()?.sampleStatus?.length) {
      @for (status of filterCriteria()?.sampleStatus ?? []; track status) {
        <span
          class="inline-flex items-center gap-2 px-3 py-1.5 bg-white border border-gray-300 rounded-lg text-sm text-text-primary"
        >
          <span class="font-medium">{{ 'shared.filterSidebar.sections.sampleStatus' | translate }}:</span>
          <span>{{ status.name }}</span>
        </span>
      }
    }
    @if (filterCriteria()?.sampleType?.length) {
      @for (sampleType of filterCriteria()?.sampleType ?? []; track sampleType) {
        <span
          class="inline-flex items-center gap-2 px-3 py-1.5 bg-white border border-gray-300 rounded-lg text-sm text-text-primary"
        >
          <span class="font-medium">{{ 'shared.filterSidebar.sections.sampleType' | translate }}:</span>
          <span>{{ sampleType.name }}</span>
        </span>
      }
    }
    @if (filterCriteria()?.facility?.length) {
      @for (facility of filterCriteria()?.facility ?? []; track facility) {
        <span
          class="inline-flex items-center gap-2 px-3 py-1.5 bg-white border border-gray-300 rounded-lg text-sm text-text-primary"
        >
          <span class="font-medium">{{ 'shared.filterSidebar.sections.facility' | translate }}:</span>
          <span>{{ facility.name }}</span>
        </span>
      }
    }
    @if (filterCriteria()?.reprocessCauses?.length) {
      @for (cause of filterCriteria()?.reprocessCauses ?? []; track cause) {
        <span
          class="inline-flex items-center gap-2 px-3 py-1.5 bg-white border border-gray-300 rounded-lg text-sm text-text-primary"
        >
          <span class="font-medium">{{ 'shared.filterSidebar.sections.reprocessCause' | translate }}:</span>
          <span>{{ cause.name }}</span>
        </span>
      }
    }
    @if (filterCriteria()?.startDate) {
      <span
        class="inline-flex items-center gap-2 px-3 py-1.5 bg-white border border-gray-300 rounded-lg text-sm text-text-primary"
      >
        <span class="font-medium">{{ 'shared.filterSidebar.dateFrom' | translate }}:</span>
        <span>{{ filterCriteria()?.startDate | date: 'dd/MM/yyyy' }}</span>
      </span>
    }
    @if (filterCriteria()?.endDate) {
      <span
        class="inline-flex items-center gap-2 px-3 py-1.5 bg-white border border-gray-300 rounded-lg text-sm text-text-primary"
      >
        <span class="font-medium">{{ 'shared.filterSidebar.dateTo' | translate }}:</span>
        <span>{{ filterCriteria()?.endDate | date: 'dd/MM/yyyy' }}</span>
      </span>
    }
    @if (filterCriteria()?.promiseStartDate) {
      <span
        class="inline-flex items-center gap-2 px-3 py-1.5 bg-white border border-gray-300 rounded-lg text-sm text-text-primary"
      >
        <span class="font-medium">{{ 'shared.activeFilters.promiseDateFrom' | translate }}:</span>
        <span>{{ filterCriteria()?.promiseStartDate | date: 'dd/MM/yyyy' }}</span>
      </span>
    }
    @if (filterCriteria()?.promiseEndDate) {
      <span
        class="inline-flex items-center gap-2 px-3 py-1.5 bg-white border border-gray-300 rounded-lg text-sm text-text-primary"
      >
        <span class="font-medium">{{ 'shared.activeFilters.promiseDateTo' | translate }}:</span>
        <span>{{ filterCriteria()?.promiseEndDate | date: 'dd/MM/yyyy' }}</span>
      </span>
    }
  </div>
  <div class="flex-shrink-0">
    <app-button
      [label]="'app.button.clearFiltersBtnTitle' | translate"
      [type]="ButtonTypeEnum.PRIMARY_OUTLINE"
      [size]="ButtonSizeEnum.MD"
      (handleClick)="onClearFilters()"
    >
    </app-button>
  </div>
</div>
